import { PlayCircleOutlined } from "@ant-design/icons";
import { Image } from "antd";
import React from "react";

type TemplateVideoPreviewCardProps = {
  url: string;
};

const TemplateVideoPreviewCard: React.FC<TemplateVideoPreviewCardProps> = ({
  url,
}) => {
  return (
    <div className="relative w-full h-full">
      <Image
        src={url}
        alt="Video Thumbnail"
        preview={false}
        className="max-w-full max-h-full object-contain block"
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.src =
            "https://dummyimage.com/600x400/ccc/ffffff.png&text=Error";
          target.alt = "Media failed to load";
        }}
      />
      <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 pointer-events-none">
        <PlayCircleOutlined className="text-white text-4xl" />
      </div>
    </div>
  );
};

export default TemplateVideoPreviewCard;
